<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'workersCrud'"
          :crudName="$t('Workers')"
          :newText="$t('Add') + '  ' + $t('New')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    const self = this;

    return {
      table: "workersTable",
      workersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "center_name",
        "units_count",
        "priority",
        "situacao",
        "modo",
        "historicos",
        "heartbeat",
        "sincronizacao",
        "actions",
      ],
      tableData: ["id", "name", "center_id", "priority", "status"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["name"],
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll",
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        listColumns: {},
        templates: {
          center_name: function (h, row) {
            return row.center ? row.center.name : "-";
          },
          units_count: function (h, row) {
            return row.units ? row.units.length : 0;
          },
          situacao: function (h, row) {
            return self.rotuloDeSituacao(h, row);
          },
          modo: function (h, row) {
            return self.rotuloDeModo(h, row);
          },
          historicos: function (h, row) {
            return self.rotuloDeHistoricos(h, row);
          },
          heartbeat: function (h, row) {
            return self.desde(row.last_heartbeat_at);
          },
          sincronizacao: function (h, row) {
            return self.rotuloDeSincronizacao(row);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["center", "units", "telemetry"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "workers",
      dataForm: {},
      margens: {
        clock_drift_warning_seconds: 5,
        clock_drift_critical_seconds: 30,
      },
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t("id"),
        name: this.$t("name"),
        center_name: this.$t("Central"),
        units_count: this.$t("Units"),
        priority: this.$t("Priority"),
        situacao: this.$t("status"),
        modo: this.$t("Write mode"),
        historicos: this.$t("History"),
        heartbeat: this.$t("Last heartbeat"),
        sincronizacao: this.$t("Last synchronization"),
        actions: this.$t("action"),
      };

      const texts = {
        filterBy: this.$t("Filter"),
        defaultOption: this.$t("Select"),
      };

      return {
        ...this.optionsOrigin,
        texts,
        headings,
      };
    },
  },
  mounted() {
    this.getMargens();
  },
  methods: {
    getMargens() {
      const api = this.$store.state.api + "workers/form/defaults";

      axios
        .get(api)
        .then((response) => {
          this.margens = { ...this.margens, ...response.data };
        })
        .catch(() => {});
    },
    estaOnline(row) {
      if (!row.status || !row.last_heartbeat_at) {
        return false;
      }

      const tolerancia = Number(row.offline_threshold_seconds || 180);
      const silencio = (Date.now() - new Date(row.last_heartbeat_at).getTime()) / 1000;

      return silencio <= tolerancia;
    },
    rotuloDeSituacao(h, row) {
      if (!row.status) {
        return h("span", { class: "badge badge-secondary" }, this.$t("Inactive"));
      }

      const online = this.estaOnline(row);

      const badge = h(
        "span",
        { class: online ? "badge badge-success" : "badge badge-danger" },
        online ? "Online" : "Offline"
      );

      const desvio = this.seloDeDesvio(h, row);

      return desvio ? h("span", [badge, " ", desvio]) : badge;
    },
    seloDeDesvio(h, row) {
      const desvio = row.telemetry ? row.telemetry.clock_drift_seconds : null;

      if (desvio === null || desvio === undefined) {
        return null;
      }

      const absoluto = Math.abs(Number(desvio));

      if (absoluto < Number(this.margens.clock_drift_warning_seconds)) {
        return null;
      }

      const critico = absoluto >= Number(this.margens.clock_drift_critical_seconds);
      const sinal = Number(desvio) > 0 ? "+" : "-";

      return h(
        "span",
        {
          class: critico ? "badge badge-danger" : "badge badge-warning",
          attrs: {
            title: this.$t(
              "Clock drift: the tracking timestamp written by this worker may be shifted"
            ),
          },
        },
        "⏱ " + sinal + absoluto + "s"
      );
    },
    rotuloDeHistoricos(h, row) {
      const selos = [];

      if (row.historico_app_habilitado) {
        selos.push(
          h("span", { class: "badge badge-primary mr-1", attrs: { title: this.$t("App position history") } }, "App")
        );
      }

      if (row.historico_movias_habilitado) {
        selos.push(
          h("span", { class: "badge badge-info mr-1", attrs: { title: this.$t("Movias position history") } }, "Movias")
        );
      }

      if (row.rastreador_habilitado) {
        selos.push(
          h("span", { class: "badge badge-dark mr-1", attrs: { title: this.$t("Receive Tags") } }, "Tag")
        );
      }

      if (row.pulsus_habilitado) {
        selos.push(
          h("span", { class: "badge badge-success", attrs: { title: this.$t("Receive Pulsus") } }, "Pulsus")
        );
      }

      return selos.length ? h("span", selos) : h("span", { class: "text-muted" }, "-");
    },
    rotuloDeModo(h, row) {
      if (!this.estaOnline(row)) {
        return "-";
      }

      const modo = row.telemetry ? row.telemetry.write_mode : null;

      if (modo === "direct") {
        return h("span", { class: "badge badge-success" }, this.$t("Direct"));
      }

      if (modo === "fallback") {
        return h(
          "span",
          {
            class: "badge badge-danger",
            attrs: { title: this.$t("Writing through the API: degraded") },
          },
          this.$t("Contingency")
        );
      }

      return "-";
    },
    rotuloDeSincronizacao(row) {
      if (!row.last_sync_at) {
        return "-";
      }

      const registros = row.telemetry ? row.telemetry.last_cycle_records : null;
      const sufixo =
        registros === null || registros === undefined ? "" : " · " + registros + " alt.";

      return this.desde(row.last_sync_at) + sufixo;
    },
    desde(valor) {
      if (!valor) {
        return "-";
      }

      const segundos = Math.floor((Date.now() - new Date(valor).getTime()) / 1000);

      if (segundos < 60) {
        return this.$t("ago") + " " + segundos + " s";
      }

      const minutos = Math.floor(segundos / 60);

      if (minutos < 60) {
        return this.$t("ago") + " " + minutos + " min";
      }

      return new Date(valor).toLocaleString();
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        priority: "priority",
      };
      let filters = "";
      $.each(query, function (index, value) {
        if (columns[index]) {
          filters += columns[index] + "=" + value + "&";
        }
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
